import type { Dispatch, SetStateAction } from 'react'

import { Alert, Modal } from 'components'

import * as S from './styles'

export interface ModalExtraMaterialsProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
  loadingConfirm?: boolean
  onReturn?: () => void
  disabled?: boolean
}

export const ModalExtraMaterials = ({
  open,
  setOpen,
  onConfirm,
  onReturn,
  disabled = false,
}: ModalExtraMaterialsProps) => {
  const handleConfirm = () => {
    onConfirm()
    setOpen(false)
  }

  const handleReturn = () => {
    onReturn && onReturn()
    setOpen(false)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Modal
      buttonAction={handleConfirm}
      buttonDisabled={disabled}
      buttonText="Prosseguir"
      closeAction={handleClose}
      modalWidth={500}
      open={open}
      returnAction={handleReturn}
      returnIcon={''}
      returnText="Editar pedido"
      setOpen={setOpen}
      showReturn
      title="Análise de volume extra"
    >
      <S.ModalContent>
        <Alert
          kind="warning"
          message={
            <S.AlertContent>
              <li>Pedidos com volume extra serão divididos em diferentes OVs.</li>
              <li>
                Mesmo que uma cor tenha estoque disponível, a garantia dela e o envio ao SAP serão
                realizados apenas quando{' '}
                <strong>todos os materiais do pedido forem aprovados.</strong>
              </li>
              <li>
                Após a aprovação, as OVs serão <strong>enviadas automaticamente ao SAP.</strong>
              </li>
            </S.AlertContent>
          }
          title="Atenção!"
        />
      </S.ModalContent>
    </Modal>
  )
}
